import React from 'react';
import IntersectionObserver from 'react-intersection-observer';

import ResponsiveImage from './responsive-image';

export class ResponsiveImageLazy extends React.Component {
    render() {
        const { srcSet, src, alt, sizes, className, ariaHidden } = this.props;
        return (
            <IntersectionObserver triggerOnce={true}>
                {
                    ({ ref, inView }) => (
                        <div ref={ref}>
                            <ResponsiveImage
                                alt={alt}
                                sizes={sizes}
                                className={className}
                                ariaHidden={ariaHidden}
                                src={inView ? src : 'https://www.sky.com/assets2/transparent.gif'}
                                srcSet={inView ? srcSet : []} />
                        </div>
                    )
                }
            </IntersectionObserver>
        );
    }
}
